import CinematicBackground from "@/components/CinematicBackground";
import { PageHeader } from "@/pages/SceneAnalysis";
import { Switch } from "@/components/ui/switch";
import { useLang } from "@/i18n/LanguageContext";
import { toast } from "@/components/ui/sonner";

export default function Settings() {
  const { t, lang, setLang, muted, toggleMute } = useLang();

  const pick = (l) => { if (l !== lang) { setLang(l); toast.success(t("langChanged")); } };

  return (
    <div className="relative px-4 pt-7" dir={lang === "ar" ? "rtl" : "ltr"} data-testid="settings-page">
      <CinematicBackground />
      <PageHeader title={t("settings_title")} icon="fa-gear" />

      {/* اللغة */}
      <h3 className="font-display text-slate-200 mb-3 flex items-center gap-2"><i className="fa-solid fa-language text-gold" /> {t("chooseLanguage")}</h3>
      <div className="space-y-3 mb-8">
        <SettingLang testId="settings-lang-ar" active={lang === "ar"} flag="🇮🇶" title="العربية" sub="Arabic Version" accent="#d9b46a" onClick={() => pick("ar")} />
        <SettingLang testId="settings-lang-en" active={lang === "en"} flag="🇬🇧" title="English" sub="International Version" accent="#4ea8ff" onClick={() => pick("en")} />
      </div>

      {/* الصوت */}
      <h3 className="font-display text-slate-200 mb-3 flex items-center gap-2"><i className="fa-solid fa-volume-high text-gold" /> {t("sound")}</h3>
      <div className="glass rounded-2xl p-4 flex items-center justify-between" data-testid="settings-sound">
        <div className="flex items-center gap-3">
          <i className={`fa-solid ${muted ? "fa-volume-xmark text-slate-500" : "fa-music text-ai"}`} />
          <div>
            <p className="text-sm text-slate-200">{t("openingSound")}</p>
            <p className="text-[11px] text-slate-400">{muted ? t("sound_off") : t("sound_on")}</p>
          </div>
        </div>
        <Switch data-testid="settings-mute-toggle" checked={!muted} onCheckedChange={() => toggleMute()} />
      </div>

      <p className="text-center text-[10px] text-slate-600 mt-10">© 2026 Mohanad Khaleel Ibrahim</p>
    </div>
  );
}

function SettingLang({ testId, active, flag, title, sub, accent, onClick }) {
  return (
    <button data-testid={testId} onClick={onClick}
      className="w-full glass rounded-2xl p-4 flex items-center gap-4 transition"
      style={active ? { border: `1px solid ${accent}`, boxShadow: `0 0 18px ${accent}44` } : { border: "1px solid rgba(255,255,255,0.08)" }}>
      <span className="text-3xl">{flag}</span>
      <div className="flex-1 text-start">
        <p className="font-display text-lg" style={{ color: active ? accent : "#e2e8f0" }}>{title}</p>
        <p className="text-[11px] text-slate-400">{sub}</p>
      </div>
      {active && <i className="fa-solid fa-circle-check" style={{ color: accent }} />}
    </button>
  );
}
